export default "__VITE_ASSET__926jajJF__"